import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import TobNavBar from "../../DashBaord/Top_navbar";
import { usePermissions } from "../../../controllers/PermissionContext";
import LottoBarGraph from "./LottoBarGraph";
import VoucherBarGraph from "./VoucherBarGraph";
import ProductsBarGraph from "./ProductsBarGraph";
import LottoRedeemBarGraph from "./LottoRedeemBarGraph";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const PERMISSION = usePermissions("statisticsReport");
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  /************************************************************************************* */
  const targetRef = useRef(null);

  const [showRequest, setShowRequest] = useState("");
  const [isRefresh, setIsRefresh] = useState(false);

  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    targetRef.current.scrollIntoView({
      behavior:'smooth',
    });
    if(PERMISSION.fullAccess === 'Y'){
      setShowRequest('Lotto');
    } else if(PERMISSION?.lotto === 'Y'){
      setShowRequest('Lotto');
    } else if(PERMISSION?.voucher === 'Y'){
      setShowRequest('Vouchers');
    } else if(PERMISSION?.products === 'Y'){
      setShowRequest('E-Commerce');
    } else if(PERMISSION?.lotto_redeem === 'Y'){
      setShowRequest('Lotto Redeem');
    }
    document.title = "Orbit Kuwait || Statistics Reports";
  }, [isRefresh]);

  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"Statistics Reports"}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="all_tabs_value">
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    className="item_tabs_main_container"
                  >
                    {(PERMISSION?.fullAccess === 'Y' || PERMISSION?.lotto === 'Y') && (
                      <Tab
                        label="Lotto"
                        className="tabs_main_contnet"
                        {...a11yProps(0)}
                        onClick={() => setShowRequest("Lotto")}
                      />
                    )}

                    {(PERMISSION?.fullAccess === 'Y' || PERMISSION?.voucher === 'Y') && (
                      <Tab
                        label="Vouchers"
                        className="tabs_main_contnet"
                        {...a11yProps(0)}
                        onClick={() => setShowRequest("Vouchers")}
                      />
                    )}
                    {(PERMISSION?.fullAccess === 'Y' || PERMISSION?.products === 'Y') && (
                      <Tab
                        label="E-Commerce"
                        className="tabs_main_contnet"
                        {...a11yProps(0)}
                        onClick={() => setShowRequest("E-Commerce")}
                      />
                    )}
                    {(PERMISSION?.fullAccess === 'Y' || PERMISSION?.lotto_redeem === 'Y') && (
                    <Tab
                      label="Lotto Redeem"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => setShowRequest("Lotto Redeem")}
                    />
                    )}
                  </Tabs>
                </div>
    
                <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                  <div className="inventory_filter_div"> 
                    <Link to={false} onClick={()=>setIsRefresh(!isRefresh)} ><FontAwesomeIcon icon={faRefresh}/></Link>
                  </div>
                </div>
              </div>
            </Box>            
            <VendorList >
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body pt-0">
                      {['Lotto','Vouchers','E-Commerce','Lotto Redeem'].includes(showRequest)?(<>
                        {showRequest === 'Lotto' && (<LottoBarGraph />)}
                        {showRequest === 'Vouchers' && (<VoucherBarGraph />)}
                        {showRequest === 'E-Commerce' && (<ProductsBarGraph />)}
                        {showRequest === 'Lotto Redeem' && (<LottoRedeemBarGraph />)}
                      </>):(
                        <h3 style={{textAlign : 'center'}}>No Data Found!</h3>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
      </div>
    </>
  );
}
